import { jsx as _jsx } from "react/jsx-runtime";
import StatsIcon from "./components/StatsIcon";
import StatsItem from "./components/StatsItem";
import StatsLabel from "./components/StatsLabel";
import StatsNumber from "./components/StatsNumber";
import StatsSeparator from "./components/StatsSeparator";
import cn from "../../utils/cn";
const Stats = ({ children, className }) => {
    return _jsx("div", { className: cn("flex animate-in flex-wrap gap-2", className), children: children });
};
Stats.Item = StatsItem;
Stats.Icon = StatsIcon;
Stats.Number = StatsNumber;
Stats.Label = StatsLabel;
Stats.Separator = StatsSeparator;
export default Stats;
